// extracted by mini-css-extract-plugin
export default {"content":"ENKHoL2Rk84GH4_WXJ73","closeButton":"VtrwCu3_J4kg7dTOqy2A"};